export default "__VITE_ASSET__JPQy1Thl__"